
<template>
  <Loader v-if="loader" />
  <div class="card">
      <div class="formgrid grid form-file">
          <div class="field col-12 md:col-5">
          <label>File</label>
          <div class="button-wrapper">
            <span :class="['label', {'active': fileToUpload.length > 0}]">
              {{fileToUpload.length > 0 ? fileToUpload[0].name : 'Seleziona File' }}
            </span>
            <input id="upload" type="file" ref="file" @change="handleFileUpload( $event )" :accept="`${Object.values(allowedType).join(', ')}`" />
          </div>
          <div class="text-center allowed-format"> Formati consentiti: {{Object.keys(allowedType).join(', ')}} </div>
          <div v-show="validationErrors.files && submitted" class="p-error">Campo richiesto.</div>
          <div v-show="validationErrors.type && submitted" class="p-error">Formato non consentito</div>
        </div>
        <div class="field col-12 md:col-5">
          <label>Data decorrenza switch</label>
          <Calendar class="w-full" v-model="data_decorrenza" dateFormat="mm-yy" view="month" :showIcon="true" />
          <div v-show="validationErrors.data_decorrenza && submitted" class="p-error">Campo richiesto.</div>
        </div>
        <div class="field col-12 md:col-2 flex align-items-center">
          <Button @click="uploadFile" class="p-button-success w-full"  label="Esegui" />
        </div>
      </div>
  </div>

  <div class="grid box-wrapper" v-if="items && Object.keys(items).length > 0">
    <div class="col-12 lg:col-6 xl:col-3 box" @click="injectData('dispatching_with_info')"> 
			<div class="card">
				<div class="flex justify-content-between mb-3">
					<div>
						<span class="block text-900 font-medium mb-3"> <small> Totale dispacciamento</small></span>
					</div>
					<div class="flex align-items-center justify-content-center bg-green-100 border-round" style="width:2.5rem;height:2.5rem">
						<i class="pi pi-arrow-circle-down text-green-500 text-xl"></i>
					</div>
				</div>
			</div>
		</div>
    <div class="col-12 lg:col-6 xl:col-3 box" @click="injectData('switch_out_ok')"> 
			<div class="card">
				<div class="flex justify-content-between mb-3">
					<div>
						<span class="block text-900 font-medium mb-3"> <small> Switch-out effettivi</small></span>
						<!-- <div class="text-600 font-medium text-xl"> totali</div> -->
					</div>
					<div class="flex align-items-center justify-content-center bg-green-100 border-round" style="width:2.5rem;height:2.5rem">
						<i class="pi pi-arrow-circle-down text-green-500 text-xl"></i>
					</div>
				</div>
			</div>
		</div>
  </div>

  <div class="card" v-if="data && data.length > 0">
    
    <h3>Dispacciamento a {{moment(data_decorrenza).locale('it').format('MMMM YYYY')}}</h3>
    <div>
        <DataTable ref="dt" :value="data"  dataKey="code" 
            :paginator="true" :rows="10" :filters="filters"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" :rowsPerPageOptions="[5,10,25]"
            currentPageReportTemplate="{first} a {last} di {totalRecords} records" responsiveLayout="scroll">
            <div class="flex justify-content-between flex-wrap my-3">
                <div class="flex align-items-center justify-content-center mb-2">
                  <span class="p-input-icon-left">
                      <i class="pi pi-search" />
                      <InputText type="search" v-model="filters['global'].value" placeholder="Cerca..." />
                  </span>
                </div>
                <div class="flex align-items-center justify-content-center">
                  <Button icon="pi pi-external-link" label="Esporta" @click="exportCSV($event)" class="p-button-secondary" />
                </div>
            </div>

            <Column field="code" header="Pod"></Column>
            <Column field="cluster" header="Cluster"></Column>
            <Column field="voltaggio" header="Tensione"></Column>
            <Column field="potenza_impegnata" header="Potenza Impegnata"></Column>
            <Column field="potenza_disponibile" header="Potenza Disponibile"></Column>
            <Column field="consumo_annuo" header="Consumo Annuo"></Column>
        </DataTable>
    </div>
  </div>





</template>

<script>
import moment from 'moment'
import Service from '@/services/ask-pratiche/pratiche-service'
import { ref, getCurrentInstance  } from 'vue';
import { FilterMatchMode } from 'primevue/api';
import Loader from '@/components/Loader.vue'


export default {
    components: {
      Loader
    },
     setup() {
      const dt = ref();
      const loader = ref(false)
      const filters = ref({
          'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
      });
      const self = getCurrentInstance();
      self.$eventBus = self.appContext.config.globalProperties.$eventBus
      self.$http = self.appContext.config.globalProperties.$http
      const service = new Service(self.$http, self.$eventBus)
      const fileToUpload = ref([])
      const items = ref()
      const data = ref()
      const allowedType = {
        'xlsx' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }

      const data_decorrenza = ref(new Date(moment(new Date()).add(1, 'month').startOf('month')))
      const validationErrors = ref({})
      const submitted = ref(false)

      const injectData = (term) => {
          data.value = items.value[term]
      }

      // const filterData = (term) => {
      //   let pods_code = items.value[term]
      //   data.value = items.value['dispatching_with_info'].filter(el => pods_code.includes(el.code))
      // }

      const handleFileUpload = async (evt) => {
        fileToUpload.value = []
        evt.preventDefault()
        submitted.value = false;
        fileToUpload.value = self.refs.file.files
      }

      const uploadFile = () => {
        submitted.value = true;
        if (validateForm()) {
          loader.value = true
          let date = moment(data_decorrenza.value).format('YYYY-MM-DD')
          service.getPrevisionalDispacciamento(fileToUpload.value, date)
          .then((res) => {
            items.value = res.items
          })
          .finally(()=>{
            loader.value = false
          }) 
        }

      }

      const validateForm = () => {

      if (fileToUpload.value.length == 0) {
          validationErrors.value['files'] = true;
          delete validationErrors.value['type'];
      } else {
        delete validationErrors.value['files'];
      }


      if (fileToUpload.value.length > 0) {
        let valid = [...fileToUpload.value].every(file => [Object.values(allowedType).join(', ')].includes(file.type), false);
        if (valid) 
          delete validationErrors.value['type'];
        else
          validationErrors.value['type'] = true;
      }

      if (!data_decorrenza.value) {
          validationErrors.value['data_decorrenza'] = true;
      } else {
        delete validationErrors.value['data_decorrenza'];
      }

      return !Object.keys(validationErrors.value).length;
    }

    const exportCSV = () => {
        dt.value.exportCSV();
      };

    return { 
      dt,
      fileToUpload,
      items,
      data,
      loader, 
      service, 
      allowedType, 
      filters,
      validationErrors,
      submitted,
      handleFileUpload,
      data_decorrenza,
      uploadFile,
      moment,
      injectData,
      exportCSV
    }
  }
}
</script>

<style scoped>

.form-file .button-wrapper {
  position: relative;
  width: 100%;
  text-align: center;
}

.form-file .allowed-format {
  font-size: 12px;
  color: rgb(186, 186, 186);
  margin-top: 2px;
}

.form-file .button-wrapper span.label {
  position: relative;
  z-index: 0;
  display: inline-block;
  width: 100%;
  background: #ffffff;
  border: 1px solid rgb(217, 217, 217) !important; 
  cursor: pointer;
  color: rgb(168, 168, 168);
  padding: 10px 2px;
  text-transform:uppercase;
  font-size:12px;
  border-radius: 3px;
}

.form-file .button-wrapper span.label.active {
  background: #2196F3;
  color: white;
}

.form-file #upload {
    display: inline-block;
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0;
    cursor: pointer;
}
.box-wrapper .box {
  cursor: pointer;
}
.box-wrapper .box .card {
    background-color: #f4f4f4;
    padding-bottom: 8px;
}
.box-wrapper .highlight .card{
  /* background: rgba(66, 244, 17, 0.195); */
  border-bottom: 6px solid rgb(18, 158, 251);
  background-color: #fff;
}
</style>
